export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20decorative%20elements%2C%20soft%20dramatic%20lighting%2C%20elegant%20movie%20palace%20atmosphere%2C%20empty%20plush%20red%20seats%2C%20grand%20architecture%2C%20warm%20amber%20and%20crimson%20tones%2C%20nostalgic%20cinema%20aesthetic%2C%20art%20deco%20details%2C%20atmospheric%20and%20inviting&width=1800&height=800&seq=hero-bg-cinema&orientation=landscape"
        alt="午马影院 - 高清影视在线观看"
        title="午马影院 - 高清不缓冲免费在线看"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl animate-fade-in-up">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white mb-4 leading-tight">
            海量高清影视
            <span className="block text-accent-400 mt-1">即点即播不卡顿</span>
          </h1>
          <p className="text-sm md:text-lg text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
            高清不缓冲免费在线看，流畅播放免费视频高清影视，免注册即点即看无需等待，海量资源尽享画质清晰不卡顿
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#featured-movies"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/25"
            >
              立即观影
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#latest-updates"
              className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-all duration-300 cursor-pointer border border-white/20"
            >
              最新推荐
              <i className="ri-fire-line ml-2"></i>
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-10 mt-10 text-white/70">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
              <div className="text-xs mt-1">影片资源</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">4K</div>
              <div className="text-xs mt-1">高清画质</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5000万+</div>
              <div className="text-xs mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">0秒</div>
              <div className="text-xs mt-1">缓冲等待</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}